<template>
  <div id="module-prefix">
    <v-autocomplete
      v-model="value"
      :items="items"
      label="Prefix"
      placeholder="Prefix"
      :item-value="'id'"
      :return-object="true"
      @change="changeEvent"
      :readonly="true"
    ></v-autocomplete>
  </div>
</template>
<script>
export default {
  props: ['module'],
  mounted () {
  },
  created () {
    this.$axios.post(`getMaxNoByModule/${this.module}`, {})
      .then((res) => {
        const response = res.data
        const defaultPrefix = response.default_prefix !== undefined ? response.default_prefix : []
        const data = [...response.all_prefix]
        this.items = [...data]
        if (defaultPrefix.length > 0) {
          this.value = { id: defaultPrefix[0].id, text: defaultPrefix[0].text }
          this.$emit('update:prefix', defaultPrefix[0].text)
        }
        if (response.no !== undefined) {
          this.$emit('update:no', response.no)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  data: function () {
    return {
      items: [],
      value: null
    }
  },
  watch: {
  },
  methods: {
    changeEvent (e) {
      var reqData = { prefix: e.text, id: e.id }
      this.$axios.post(`getMaxNoByModule/${e.module}`, reqData)
        .then((res) => {
          this.$emit('update:prefix', e.text)
          if (res.data.no !== undefined) {
            this.$emit('update:no', res.data.no)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
}
</script>
<style lang="scss">
</style>
